export default __webpack_public_path__ + "static/media/group-therapy-conversation_179970-1119.99c22ca2.jpg";